import { VueModule } from '@Foundation';
import Flipper from './code/Scripts/components/flipper';

export default VueModule({
  components: {
    Flipper
  }
});
